import { BrowserRouter } from 'react-router-dom';

import { AppRoutes } from './AppRoutes';
import { AppProviders } from './AppProviders';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';

export const App = () => (
  <BrowserRouter>
    <AppProviders>
      <AppRoutes />
    </AppProviders>
  </BrowserRouter>
);
